import { normalizar } from './mesclar';

/**
 * Filtros anti-alucinação do Whisper. Os três primeiros são os limiares
 * clássicos do modelo; a lista de frases pega os bordões que ele inventa em
 * silêncio (legendas de vídeo aparecem no material de treino em português).
 */
export const LIMIARES_ALUCINACAO = {
  noSpeechProbMaximo: 0.6,
  avgLogprobMinimo: -1.0,
  compressionRatioMaximo: 2.4,
} as const;

export const FRASES_ALUCINACAO = [
  'legendas pela comunidade amara.org',
  'legendas pela comunidade',
  'amara.org',
  'inscreva-se no canal',
  'obrigado por assistir',
  'ate a proxima',
] as const;


export interface SegmentoBruto {
  texto: string;
  inicioMs: number;
  fimMs: number;
  noSpeechProb?: number | null;
  avgLogprob?: number | null;
  compressionRatio?: number | null;
}

const FRASES = FRASES_ALUCINACAO.map((f) => f.split(' ').map(normalizar).join(' '));

/**
 * Whisper preenche silêncio com bordão. Os três limiares são os do próprio
 * modelo; a lista de frases pega o que ele inventa em português, que vem de
 * legenda de vídeo no material de treino. Descartar cedo evita que uma ata
 * termine com "inscreva-se no canal".
 */
export function pareceAlucinacao(segmento: SegmentoBruto): boolean {
  if (
    typeof segmento.noSpeechProb === 'number' &&
    segmento.noSpeechProb > LIMIARES_ALUCINACAO.noSpeechProbMaximo
  ) {
    return true;
  }
  if (
    typeof segmento.avgLogprob === 'number' &&
    segmento.avgLogprob < LIMIARES_ALUCINACAO.avgLogprobMinimo
  ) {
    return true;
  }
  if (
    typeof segmento.compressionRatio === 'number' &&
    segmento.compressionRatio > LIMIARES_ALUCINACAO.compressionRatioMaximo
  ) {
    return true;
  }

  const texto = segmento.texto.split(/\s+/).map(normalizar).filter(Boolean).join(' ');
  if (texto.length === 0) return true;
  return FRASES.some((frase) => frase.length > 0 && texto === frase);
}
